export const getIsDefaultThumbnail = (thumbnailImageUrl: string) => {
  const defaultThumbnail = 'assets/placeholder_live_solidsport'
  const replayDefaultThumbnail = 'assets/placeholder_replay_solidsport'
  return (
    thumbnailImageUrl.includes(defaultThumbnail) ||
    thumbnailImageUrl.includes(replayDefaultThumbnail)
  )
}
